const Company = resolve => {
  require.ensure(
    ["../views/company/Index.vue"],
    () => {
      resolve(require("../views/company/Index.vue"));
    },
    "Company"
  );
};

const CompanyPanel = resolve => {
  require.ensure(
    ["../views/company/CompanyPanel.vue"],
    () => {
      resolve(require("../views/company/CompanyPanel.vue"));
    },
    "CompanyPanel"
  );
};

const Schedules = resolve => {
  require.ensure(
    ["../views/company/Schedules.vue"],
    () => {
      resolve(require("../views/company/Schedules.vue"));
    },
    "Schedules"
  );
};

const Rooms = resolve => {
  require.ensure(
    ["../views/company/Rooms.vue"],
    () => {
      resolve(require("../views/company/Rooms.vue"));
    },
    "Rooms"
  );
};
const RoomDetails = resolve => {
  require.ensure(
    ["../views/company/Rooms.vue"],
    () => {
      resolve(require("../views/company/RoomDetails.vue"));
    },
    "Rooms"
  );
};

const SignUps = resolve => {
  require.ensure(
    ["../views/company/SignUps.vue"],
    () => {
      resolve(require("../views/company/SignUps.vue"));
    },
    "SignUps"
  );
};

const Commitment = resolve => {
  require.ensure(
    ["../views/company/Commitment.vue"],
    () => {
      resolve(require("../views/company/Commitment.vue"));
    },
    "Commitment"
  );
};

const Dashboard = resolve => {
  require.ensure(
    ["../views/company/Dashboard.vue"],
    () => {
      resolve(require("../views/company/Dashboard.vue"));
    },
    "Dashboard"
  );
};

const Departments = resolve => {
  require.ensure(
    ["../views/company/Departments.vue"],
    () => {
      resolve(require("../views/company/Departments.vue"));
    },
    "Departments"
  );
};

const Totem = resolve => {
  require.ensure(
    ["../views/company/Totem.vue"],
    () => {
      resolve(require("../views/company/Totem.vue"));
    },
    "Totem"
  );
};

const Inicio = resolve => {
  require.ensure(
    ["../views/company/Inicio.vue"],
    () => {
      resolve(require("../views/company/Inicio.vue"));
    },
    "Inicio"
  );
};

const Home = resolve => {
  require.ensure(
    ["../views/company/Home.vue"],
    () => {
      resolve(require("../views/company/Home.vue"));
    },
    "Home"
  );
}
const Visitors = resolve => {
  require.ensure(
    ["../views/company/Inicio.vue"],
    () => {
      resolve(require("../views/company/Visitors.vue"));
    },
    "Inicio"
  );
};

exports.Company = Company;
exports.CompanyPanel = CompanyPanel;
exports.Schedules = Schedules;
exports.Rooms = Rooms;
exports.SignUps = SignUps;
exports.Departments = Departments;
exports.Totem = Totem;
exports.Inicio = Inicio;
exports.Dashboard = Dashboard;
exports.Commitment = Commitment;
exports.RoomDetails = RoomDetails;
exports.Vistors = Visitors;
exports.Home = Home;
exports.Visitors = Visitors;